var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"loading":_vm.loading,"signInWithPhoneNumber":_vm.signInWithPhoneNumber,"verifyPhoneNumber":_vm.verifyPhoneNumber,"resendVerificationCode":_vm.resendVerificationCode})],2)}
var staticRenderFns = []

export { render, staticRenderFns }